/**
 * Download & Press Area — image gallery modal (ES6, no jQuery).
 *
 * Opens a shared modal populated from data-* attributes on gallery items.
 * Progressive enhancement: thumbnails retain a direct download link so the
 * feature degrades gracefully without JS.
 */

const modal = document.getElementById('download-modal');
if (!modal) {
    // No download area on this page — nothing to do.
} else {
    const modalImg        = document.getElementById('download-modal-img');
    const modalTitle      = document.getElementById('download-modal-title');
    const modalSubline    = document.getElementById('download-modal-subline');
    const modalPhotographer = document.getElementById('download-modal-photographer');
    const modalCopyright  = document.getElementById('download-modal-copyright');
    const modalCaption    = document.getElementById('download-modal-caption');
    const modalDownload   = document.getElementById('download-modal-download');
    const closeBtn        = document.getElementById('download-modal-close');

    /** @param {HTMLElement} item */
    function openModal(item) {
        modalImg.src         = item.dataset.modalSrc || '';
        modalImg.alt         = item.dataset.modalAlt || '';
        modalTitle.textContent       = item.dataset.modalTitle || '';
        modalSubline.textContent     = item.dataset.modalSubline || '';
        modalPhotographer.textContent = item.dataset.modalPhotographer || '';
        modalCopyright.textContent   = item.dataset.modalCopyright || '';
        modalCaption.textContent     = item.dataset.modalCaption || '';
        modalDownload.href           = item.dataset.modalDownload || '#';

        modal.hidden = false;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
    }

    function closeModal() {
        modal.classList.remove('is-open');
        modal.hidden = true;
        document.body.style.overflow = '';
    }

    // Open on thumbnail click or Enter keypress (keyboard accessibility)
    document.querySelectorAll('.download-gallery__item img').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
            openModal(thumb.closest('.download-gallery__item'));
        });
        thumb.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openModal(thumb.closest('.download-gallery__item'));
            }
        });
    });

    // Close on close button
    closeBtn.addEventListener('click', closeModal);

    // Close on overlay click (outside dialog box)
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    // Close on Esc
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
}
